import { showMessageBox } from "./machine_app_toast_message_box";

export const modalMessageBox = function(pMessage, pLevel) {
  showMessageBox(
    pMessage,
    pLevel,
    {
      closeButton: true,
      positionClass: `toast-middle-offset-lowered`,
      toastClass: `machineapps-toast-modal-${pLevel}`,
      target: '.ml_modal_body',
      preventDuplicates : true
    }
  );
};